var map = {
	"./b7casino.css": [
		57803,
		792
	],
	"./bdmbet.css": [
		68651,
		792
	],
	"./betonred-ng.css": [
		29790,
		792
	],
	"./betonred.css": [
		9008,
		792
	],
	"./betsixty.css": [
		92509,
		792
	],
	"./brunocasino.css": [
		77770,
		792
	],
	"./cryptoleo.css": [
		77358,
		792
	],
	"./ivybet.css": [
		20456,
		792
	],
	"./jokabet.css": [
		86361,
		792
	],
	"./kinghills.css": [
		91004,
		792
	],
	"./legendspin.css": [
		35724,
		792
	],
	"./memocasino.css": [
		85688,
		792
	],
	"./ninecasino.css": [
		12682,
		792
	],
	"./ninewin.css": [
		44413,
		792
	],
	"./nomaspin.css": [
		44168,
		792
	],
	"./polispin.css": [
		76989,
		792
	],
	"./r2pbet.css": [
		27446,
		792
	],
	"./wbetz.css": [
		73585,
		792
	],
	"./winaura.css": [
		90172,
		792
	],
	"./zumospin.css": [
		956,
		792
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 88183;
module.exports = webpackAsyncContext;